// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__331B_","calendarButtons":"ClockData_calendarButtons__1PzoK"};